import React, { useEffect } from 'react';
import { translate } from '@fiverr-private/i18n-react';
import { Container } from '@fiverr-private/layout_components';
import { Text, Link, Heading } from '@fiverr-private/typography';
import { UnorderedList, ListItem } from '@fiverr-private/list';
import { trackPageMetaData } from '../../shared/gtmTracking';

const RegistrationSuccess: React.FC = () => {
  useEffect(() => {
    trackPageMetaData();
  }, []);

  return (
    <Container>
      <Heading as="h2" paddingBottom="2">
        {translate('affiliates_signup_perseus.thank_you.title')}
      </Heading>
      <Container paddingBottom="3">
        <Text paddingY="2" size="b_sm">
          {translate('affiliates_signup_perseus.thank_you.received')}
        </Text>
        <Text paddingY="2" size="b_sm">
          {translate('affiliates_signup_perseus.thank_you.excited')}
        </Text>
      </Container>
      <Container paddingBottom="3">
        <Heading as="h3" paddingBottom="2" size="h_xs">
          {translate('affiliates_signup_perseus.thank_you.what_happens_next')}
        </Heading>
        <UnorderedList>
          <ListItem>
            <Text as="span" size="b_sm">
              {translate('affiliates_signup_perseus.thank_you.application_review')}
            </Text>
          </ListItem>
          <ListItem>
            <Text as="span" size="b_sm">
              {translate('affiliates_signup_perseus.thank_you.email_notification')}
            </Text>
          </ListItem>
          <ListItem>
            <Text as="span" size="b_sm">
              {translate('affiliates_signup_perseus.thank_you.get_ready')}
            </Text>
          </ListItem>
        </UnorderedList>
      </Container>
      <Container paddingBottom="3">
        <Text paddingY="2" size="b_sm" color="bodySecondary">
          {translate('affiliates_signup_perseus.thank_you.head_start')}
        </Text>
      </Container>
      <Container paddingBottom="3">
        <Heading as="h3" paddingBottom="2" size="h_xs">
          {translate('affiliates_signup_perseus.thank_you.while_you_wait')}
        </Heading>
        <UnorderedList>
          <ListItem>
            <Text as="span" size="b_sm">
              <Link
                href="https://affiliates.fiverr.com/blog/earn-more-with-the-new-fiverr-affiliate-program-commission-structure/"
                target="_blank"
                rel="noopener noreferrer"
              >
                {translate('affiliates_signup_perseus.thank_you.learn_program')}
              </Link>
            </Text>
          </ListItem>
          <ListItem>
            <Text as="span" size="b_sm">
              <Link href="https://www.youtube.com/watch?v=dRa8Vkg7Yww" target="_blank" rel="noopener noreferrer">
                {translate('affiliates_signup_perseus.thank_you.success_stories')}
              </Link>
            </Text>
          </ListItem>
        </UnorderedList>
      </Container>
      <Container paddingTop="2">
        <Text size="b_sm">Fiverr Affiliates Team.</Text>
      </Container>
    </Container>
  );
};

export default RegistrationSuccess;
